export default {
    formatAmount(amount: number, precision = 0) {
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'decimal',
            maximumFractionDigits: precision,
        });

        return formatter.format(amount);
    },
    formatCurrency(amount: number) {
        const formatter = new Intl.NumberFormat('en-GB', {style: 'currency', currency: 'GBP'});

        return formatter.format(amount);
    },
};
